export const HOME = '/'

export const AUTH = '/auth'
export const LOGIN = AUTH + '/login'
export const SSO_LOGIN = AUTH + '/sso-login'

export const COMPANY_LIST = '/company-list'
export const DASHBOARD = '/dashboard'
export const LM_DASHBOARD = '/lm-dashboard'
export const HR_DASHBOARD = '/hr-dashboard'
// Ungated router that every guard falls back to: forwards to the first dashboard or screen the
// user is granted (pages/landing/Landing). The dashboards are grants now, so none can be the fallback.
export const LANDING = '/start'
export const HELP = '/help'

// In-app notifications (served by sso-service, public.notifications scoped to ERPBOI_HRM).
// Reached from the topbar bell's "View all"; not a sidebar menu item.
export const NOTIFICATIONS = '/notifications'

//ess (Employee Self Service) — the "My …" self-service hub. Every child url
// starts with /ess (RR6 needs child abs-paths to start with the parent link).
export const ESS = '/ess'
export const MY_PROFILE = ESS + '/my-profile'
export const MY_LEAVE = ESS + '/my-leave'
export const MY_LOANS = ESS + '/my-loans'
export const MY_PAYSLIPS = ESS + '/my-payslips'
export const MY_TAX_CERT = ESS + '/my-tax-certificate'
export const MY_PF = ESS + '/pf-balance'
export const MY_GF = ESS + '/gf-balance'
// Compensatory off — the employee's own claims + credit ledger. Spending a credit
// happens on MY_LEAVE (the comp-off-flagged leave type draws on the same ledger).
export const MY_COMP_OFF = ESS + '/my-comp-off'
export const ATTENDANCE_REQUEST = ESS + '/attendance-request'
export const TEAM_ATTENDANCE = ESS + '/team-attendance'

//hrm
export const HRM = '/hrm'
export const EMPLOYEE = HRM + '/employee'
export const EMPLOYEE_ADD = HRM + '/employee/add'
export const EMPLOYEE_EDIT: (p: {id: string}) => string = ({id}) => `${HRM}/employee/edit/${id}`
export const EMPLOYEE_VIEW: (p: {id: string}) => string = ({id}) => `${HRM}/employee/view/${id}`
export const EMPLOYEE_USER_MAPPING = HRM + '/emp-usr-map'
export const INCREMENT = HRM + '/increment'
export const PROMOTION = HRM + '/promotion'
export const SEPARATION = HRM + '/separation'
export const LOAN_ADVANCE = HRM + '/loan-advance'
export const APPRAISAL = HRM + '/appraisals'
export const ALL_PAYSLIPS = HRM + '/all-payslips'
export const ALL_TAX_CERT = HRM + '/all-tax-certificate'
// MY_LOANS / MY_PAYSLIPS / MY_TAX_CERT moved to the //ess section above.
export const PAYSLIP_DETAIL: (p: {id: string}) => string = ({id}) => `${HRM}/payslip/${id}`

//leave & attendance (combined top menu "Leave & Attn")
export const LEAVE_ATTN = '/leave-attn'
export const LEAVE_FOR_EMPLOYEE = LEAVE_ATTN + '/leave-for-employee'
export const ATTENDANCE_FOR_EMPLOYEE = LEAVE_ATTN + '/attendance-for-employee'
// Employee Attendance (company-wide HR/admin monthly register) — under "Leave & Attn".
export const EMPLOYEE_ATTENDANCE = LEAVE_ATTN + '/employee-attendance'
// Employee Leave (company-wide HR/admin leave register) — the leave counterpart of Employee Attendance.
export const EMPLOYEE_LEAVE = LEAVE_ATTN + '/employee-leave'
// Leave Type master (setup) — moved from Settings into "Leave & Attn" 2026-08-07.
export const LEAVE_TYPE = LEAVE_ATTN + '/leave-type'
// Claim compensatory off on behalf of an employee (HR/admin).
export const COMP_OFF_FOR_EMPLOYEE = LEAVE_ATTN + '/comp-off-for-employee'
// ATTENDANCE_REQUEST / TEAM_ATTENDANCE / MY_LEAVE moved to //ess.
// Leave/Attendance are approved under //approvals (Pending Approvals).

//payroll
export const PAYROLL = '/payroll'
export const EMPLOYEE_PAYROLL = PAYROLL + '/emp-payroll'
export const PAYROLL_RUNS = PAYROLL + '/runs'
export const PAYROLL_RUN_DETAIL: (p: {id: string}) => string = ({id}) => `${PAYROLL}/runs/${id}`
export const PAYROLL_BANK_CONFIG = PAYROLL + '/bank-config'
export const TAX_CONFIG = PAYROLL + '/tax-config'
export const PROVIDENT_FUND = PAYROLL + '/provident-fund'
export const GRATUITY_FUND = PAYROLL + '/gratuity-fund'
export const ATTENDANCE_PAY = PAYROLL + '/attendance-pay'
export const AMOUNT_ROUNDING = PAYROLL + '/amount-rounding'
export const PAYROLL_ELM = PAYROLL + '/payroll-elm'

//performance (Appraisals moved to the HRM/Employee menu → APPRAISAL is defined in the //hrm section)
export const PERFORMANCE = '/performance'

//approvals — one queue across every approval document type, like store's: what I filed, and what
// waits on my decision. Each url is the gating feature url (auth.features.url). A row of Pending
// Approvals opens its type's review drawer; there is no per-type approval page any more.
export const APPROVALS = '/approvals'
export const MY_REQUESTS = APPROVALS + '/my-requests'
export const PENDING_APPROVALS = APPROVALS + '/pending-approvals'
// Bookmarks and old bell links to the retired per-type pages (/my-approvals/<type>) land here.
export const LEGACY_MY_APPROVALS = '/my-approvals/*'
// Worker leave / attendance are approved in the labor console's own Approvals (labor-service's
// engine) since 2026-10-02 — not here.

//settings
export const SETTINGS = '/settings'
export const POLICY = SETTINGS + '/policy'
export const DEPARTMENT = SETTINGS + '/department'
export const DESIGNATION = SETTINGS + '/designation'
export const EMP_TYPE = SETTINGS + '/emp-type'
export const EMPLOYMENT_STATUS = SETTINGS + '/employment-status'
export const GRADES = SETTINGS + '/grades'
export const SHIFTS = SETTINGS + '/shifts'
export const OFFICE_LOCATION = SETTINGS + '/office-location'
export const APPR_PARAM = SETTINGS + '/appraisal-param'

export const WEEKEND = SETTINGS + '/weekend'
export const HOLIDAY = SETTINGS + '/holiday'
export const CALENDAR = SETTINGS + '/calendar'
export const APPROVAL_WORKFLOW = SETTINGS + '/approval-workflow'
// Company compensatory-off policy (validity window, backdating, qualifying day types).
export const COMP_OFF_CONFIG = SETTINGS + '/comp-off-config'
// Company employee-code format (AUTO/MANUAL, prefix, digits). The url is the permission key.
export const EMP_CODE_CONFIG = SETTINGS + '/employee-code'
export const SECTION = SETTINGS + '/section'
export const UNIT = SETTINGS + '/unit'

//reports (HRM)
export const REPORTS = '/reports'
export const RPT_EMPLOYEE = REPORTS + '/employee'
export const RPT_APPRAISAL = REPORTS + '/appraisal'
export const RPT_PAYROLL = REPORTS + '/payroll'
export const RPT_ATTN_SUMMARY = REPORTS + '/attn-leave-summary'
export const RPT_MONTHLY_ATTENDANCE = REPORTS + '/monthly-attendance'
export const RPT_PF = REPORTS + '/pf'
export const RPT_GF = REPORTS + '/gf'
export const RPT_TAX_CERT = REPORTS + '/tax-certificate'
